export enum ApplicationStatus {
  draft = "draft",
  open = "open",
  accepted = "accepted",
  denied = "denied",
  cancelled = "cancelled",
}
